import React, { useContext, useState, useEffect } from "react"
import { auth } from "../firebase"
import { useHistory } from "react-router-dom"
const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  let history = useHistory()
  const [currentUser, setCurrentUser] = useState()
  const [loading, setLoading] = useState(true)
  
  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password)
  }

  function login(email, password) {
    localStorage.setItem('user', email);
    return auth.signInWithEmailAndPassword(email, password)
  }
  

  function logout() {
    localStorage.clear();
    return auth.signOut()
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email)
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email)
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password)
  }

  // Helper function to get the token from cookies
  // function getCookie(name) {
  //   const value = `; ${document.cookie}`;
  //   const parts = value.split(`; ${name}=`);
  //   if (parts.length === 2) return parts.pop().split(';').shift();
  //   return null;
  // }

  // function getCookie(name) {
  //   const value = `; ${document.cookie}`;
  //   console.log(document.cookie, 51);

  //   console.log(value, 53);
    
  //   const parts = value.split(`; ${name}=`);
  //   console.log(parts, 56);
  //   console.log(parts.pop().split(';').shift(), 57);
 
  //   if (parts.length === 2) return parts.pop().split(';').shift();
  // }
  
//   function getCookieValue(cookieName) {
//     const cookies = document.cookie.split('; ');
//     const cookie = cookies.find(row => row.startsWith(`${cookieName}=`));
//     return cookie ? cookie.split('=')[1] : null;
// }
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

  // New function to login using a token stored in cookies
  const loginWithToken = async ()=> {
    const token = getCookie('customToken');
    console.log(token, 58);
    
    if (!token) {
      return Promise.reject(new Error('No token found'));
    }

    // Sign in with the custom token
    return auth.signInWithCustomToken(token)
      .then((userCredential) => {
        const user = userCredential.user;
        setCurrentUser(user);

        // Save the user's email in localStorage
        localStorage.setItem('user', user.email);

        return user;
      })
      .catch((error) => {
        console.error("Error logging in with token:", error);
        return Promise.reject(error);
      });
  }
  
  const LoginWithToken = async () => { 
      try{
        await loginWithToken()


      }
      catch(err){
        console.log(err);
        
      }

  }

  useEffect(() => {
    LoginWithToken()

    
    // history.push('/dashboard')

    const unsubscribe = auth.onAuthStateChanged(user => {
      console.log(user, 122);
      
      setCurrentUser(user)
      setLoading(false)
    })

    return unsubscribe
  }, [])

  const value = {
    currentUser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
